// extracted by mini-css-extract-plugin
export default {"actions":"b40e332fe40be4c2","action":"_7ce2fc993342e43e","approvalCommentCommentCell":"_502145f851a79e6d"};